<template>
  <div>
    <div class="bg-white shadow p-2 mb-3">
      <div class="row">
        <div v-if="isReportReader" class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Instansi / OPD</label>
            <div class="col-sm-8">
              <v-select
                v-model="filter.companyId"
                :options="listCompanies"
                :reduce="item => item.ID"
                placeholder="Instansi / OPD"
                @input="onRefresh"
                label="Name"/>
            </div>
          </div>
        </div>
        <!-- <div class="col">&nbsp;</div> -->
        <div v-if="isReportReader" class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tipe Pegawai</label>
            <div class="col-sm-8">
              <v-select
                v-model="filter.employeeTypeId"
                :options="listEmployeeTypes"
                :reduce="item => item.ID"
                placeholder="Tipe Pegawai"
                @input="onRefresh"
                label="Name"/>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tahun</label>
            <div class="col-sm-8">
              <v-select v-model="filter.year" :options="$constant.LIST_YEARS" />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Bulan</label>
            <div class="col-sm-8">
              <v-select
                v-model="filter.month"
                :options="$constant.LIST_MONTHS"
                :reduce="item => item.ID"
                label="Name" />
            </div>
          </div>
        </div>

      </div>

      <div class="row mt-2">
        <div class="col">
          <button class="btn btn-sm btn-primary btn-icon-split" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-search" /></span>
            <span class="text">Cari <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>

        <div class="col text-right">
          <button class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onPrint" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak <b-spinner small v-show="isLoading" /></span>
          </button>
          <button v-if="isReportReader" class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onPrintAlpha" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak Alpha <b-spinner small v-show="isLoading" /></span>
          </button>
          <button v-if="isReportReader" class="btn btn-sm btn-success btn-icon-split text-dark mr-2" @click="exportToExcel" :disabled="isLoading">
            <span class="icon"><i class="fas fa-file-excel" /></span>
            <span class="text">Export Alpha <b-spinner small v-show="isLoading" /></span>
          </button>
          <!-- <button v-if="isReportReader" class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onPrintRekom" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak Rekom <b-spinner small v-show="isLoading" /></span>
          </button> -->

          <button v-if="isReportReader2" class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onPrintOPD" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak Rekap OPD<b-spinner small v-show="isLoading" /></span>
          </button>
        </div>
        
      </div>
    </div>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="filter"
      :search="search"
      @onDblClicked="item => showDetail(item)"
      @onSelectItem="selectedItem = $event">

      <template #caption>
        <span class="table-cap bg-warning p-1 mr-2">TL: Terlambat</span>
        <span class="table-cap bg-secondary p-1 text-light">PSW: Pulang Sebelum Waktu</span>
      </template>

    </AppTable>

    <b-modal id="modalPrint" hide-footer no-close-on-backdrop size="xl" title="Cetak Presensi Pegawai" header-class="bg-light text-primary py-1">

      <iframe ref="printFrame" id="printFrame" class="w-100" height="600" name="printFrame"></iframe>

      <div class="text-center">
        <button class="btn btn-primary" @click="printToPDF">Print</button>
      </div>
    </b-modal>

    <b-modal id="modalPrintRekom" hide-footer no-close-on-backdrop size="xl" title="Cetak Rekom" header-class="bg-light text-primary py-1">

      <iframe ref="printRekomFrame" id="printFrame" class="w-100" height="600" name="printRekomFrame"></iframe>

      <div class="text-center">
        <button class="btn btn-primary" @click="printRekomToPDF">Print</button>
        <!-- <button class="btn btn-primary" @click="exportRekomToExcel">Export EXcel</button> -->
      </div>
    </b-modal>

    <b-modal id="modalDetail" v-if="selectedItem" hide-footer no-close-on-backdrop size="lg" :title="`Detail Presensi ${selectedItem.Name}`" header-class="bg-light text-primary py-1">
      <table class="table text-center">
        <tr>
          <th>Tanggal</th>
          <th>Jam Masuk</th>
          <th>Jam Pulang</th>
          <th>Keterangan</th>
        </tr>
        <tr v-for="d in selectedItem.DailyLogs">
          <td>{{ d.Day }}</td>
          <td>{{ d.FirstAttend ? d.FirstAttend : '-' }}</td>
          <td>{{ d.LastAttend ? d.LastAttend : '-' }}</td>
          <td>
            <span v-if="d.Status == ''" class="badge badge-success">Masuk</span>
            <span v-else :class="`badge badge-${d.StatusVariant}`">{{ d.Status }}</span>
          </td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppTable },
  mounted() {
    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/attendance-monthly-report',
      tableFields: [
        { key: 'index', label: 'No.', class: 'column-width-20' },
        { key: 'EmployeeIdNumber', label: 'NIP' },
        { key: 'Name', label: 'Nama', class: 'column-name-width' },
        { key: 'JumlahHari', label: 'Hari' },
        { key: 'JumlahLibur', label: 'Libur' },
        { key: 'JumlahTugasDinas', label: 'Tugas Dinas', variant: 'success' },
        { key: 'JumlahTugasBelajar', label: 'Tugas Belajar', variant: 'warning' },
        { key: 'JumlahSakit', label: 'Sakit', variant: 'warning' },
        { key: 'JumlahTidakMasukKeterangan', label: 'Ijin', variant: 'warning' },
        { key: 'Cuti', label: 'Cuti', variant: 'warning', formatter: (value, key, item) => {
          return item.JumlahCuti + item.JumlahCutiBesar + item.JumlahCTLN
        }},
        { key: 'JumlahKesalahan', label: 'Kendala Mesin', variant: 'secondary' },
        { key: 'JumlahAlpa', label: 'Alpha', variant: 'danger' },
        { key: 'JumlahNonApel', label: 'Tidak Apel', variant: 'danger' },
        { key: 'JumlahTerlambat1', label: 'TL1', variant: 'warning' },
        { key: 'JumlahTerlambat2', label: 'TL2', variant: 'warning' },
        { key: 'JumlahTerlambat3', label: 'TL3', variant: 'warning' },
        { key: 'JumlahTerlambat4', label: 'TL4', variant: 'warning' },
        { key: 'JumlahPulangCepat1', label: 'PSW1', variant: 'secondary' },
        { key: 'JumlahPulangCepat2', label: 'PSW2', variant: 'secondary' },
        { key: 'JumlahPulangCepat3', label: 'PSW3', variant: 'secondary' },
        { key: 'JumlahPulangCepat4', label: 'PSW4', variant: 'secondary' },
        { key: 'ProsentaseKehadiran', label: 'Kehadiran (%)', formatter: value => `${value} %` },
        { key: 'TotalProsentasePengurangan', label: 'Pengurangan (%)', formatter: value => `${value} %` },
      ],
      selectedItem: null,
      search: '',
      filter: {
        companyId: JSON.parse(localStorage.getItem('userData')).employee.CompanyID,
        employeeTypeId: null,
        weeklyScheduleCategoryId: null,
        year: (new Date()).getFullYear(),
        month: (new Date()).getMonth() + 1
        // month: 4
      },
      listCompanies: [],
      listEmployeeTypes: [],
      withoutFormManualCapture: false,
      // listWeeklyScheduleCategories: []
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    isReportReader () {
      return this.$store.state.user.userData.roles.some(item => (item.ID === 1 || item.ID === 5 || item.ID === 4 || item.ID === 7))
    },
    isReportReader2 () {
      return this.$store.state.user.userData.roles.some(item => (item.ID === 1 || item.ID === 6 || item.ID === 7 || item.ID === 8))
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.all([
        this.$axios.get('/company'),
        this.$axios.get('/employee-type'),
      ]).then(this.$axios.spread((...res) => {
        this.listCompanies = res[0].data
        this.listEmployeeTypes = res[1].data
      }))
    },
    
    showDetail (item) {
      this.selectedItem = (item.constructor === Object) ? item : this.selectedItem

      this.$bvModal.show('modalDetail')
    },

    onPrint () {
      this.$bvModal.show('modalPrint')

      this.generateReport().then(data => {

        this.$nextTick(function () {
          this.$refs.printFrame.srcdoc = data
        })
      })
    },

    onPrintAlpha () {
      this.$bvModal.show('modalPrint')

      this.generateReportAlpha().then(data => {

        this.$nextTick(function () {
          this.$refs.printFrame.srcdoc = data
        })
      })
    },

    onPrintOPD () {
      this.$bvModal.show('modalPrint')

      this.generateReportOPD().then(data => {

        this.$nextTick(function () {
          this.$refs.printFrame.srcdoc = data
        })
      })
    },

    onPrintRekom () {
      this.$bvModal.show('modalPrintRekom')

      this.generateReportRekom().then(data => {

        this.$nextTick(function () {
          this.$refs.printRekomFrame.srcdoc = data
        })
      })
    },

    onPrintRekomOPD () {
      this.$bvModal.show('modalPrintRekom')

      this.generateReportRekomOPD().then(data => {

        this.$nextTick(function () {
          this.$refs.printRekomFrame.srcdoc = data
        })
      })
    },

    generateReport () {
      const params = this.filter

      return this.$axios.get(this.apiUrl, { params }).then(res => {

        const head = `
          <h2 class="text-center">REKAP PRESENSI PEGAWAI</h2>
          <h2 class="text-center">${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}</h2>
          <h2 class="text-center underlined">BULAN ${this.$helper.getMonthName(this.filter.month)} ${this.filter.year}</h2>
          <br>

          <table border="1">
          <tr>
            <th>NO</th>
            <th>NIP</th>
            <th>Nama</th>
            <th>Jumlah Hari</th>
            <th>Jumlah Libur</th>
            <th>Tugas Dinas</th>
            <th>Tugas Belajar</th>
            <th>Sakit</th>
            <th>Ijin</th>
            <th>Cuti</th>
            <th>Kendala Mesin</th>
            <th>Alpha</th>
            <th>Tidak Apel</th>
            <th>TL1</th>
            <th>TL2</th>
            <th>TL3</th>
            <th>TL4</th>
            <th>PSW1</th>
            <th>PSW2</th>
            <th>PSW3</th>
            <th>PSW4</th>
            <th>Kehadiran (%)</th>
            <th>Pengurangan (%)</th>
          </tr>
        `

        let totalJumlahHari = 0
        let totalJumlahLibur = 0
        let totalJumlahTugasDinas = 0
        let totalJumlahTugasBelajar = 0
        let totalJumlahSakit = 0
        let totalJumlahTidakMasukKeterangan = 0
        let totalJumlahCuti = 0
        let totalJumlahKesalahan = 0
        let totalJumlahAlpa = 0
        let totalJumlahNonApel = 0
        let totalJumlahTerlambat1 = 0
        let totalJumlahTerlambat2 = 0
        let totalJumlahTerlambat3 = 0
        let totalJumlahTerlambat4 = 0
        let totalJumlahPulangCepat1 = 0
        let totalJumlahPulangCepat2 = 0
        let totalJumlahPulangCepat3 = 0
        let totalJumlahPulangCepat4 = 0

        const rows = res.data.rows

        let content = ''
        for (var i = 0; i < rows.length; i++) {
          content += `
            <tr>
              <td>${i+1}</td>
              <td>${rows[i].EmployeeIdNumber}&nbsp;</td>
              <td>${rows[i].Name}</td>
              <td>${rows[i].JumlahHari}</td>
              <td>${rows[i].JumlahLibur}</td>
              <td>${rows[i].JumlahTugasDinas}</td>
              <td>${rows[i].JumlahTugasBelajar}</td>
              <td>${rows[i].JumlahSakit}</td>
              <td>${rows[i].JumlahTidakMasukKeterangan}</td>
              <td>${rows[i].JumlahCuti + rows[i].JumlahCutiBesar + rows[i].JumlahCTLN}</td>
              <td>${rows[i].JumlahKesalahan}</td>
              <td>${rows[i].JumlahAlpa}</td>
              <td>${rows[i].JumlahNonApel}</td>
              <td>${rows[i].JumlahTerlambat1}</td>
              <td>${rows[i].JumlahTerlambat2}</td>
              <td>${rows[i].JumlahTerlambat3}</td>
              <td>${rows[i].JumlahTerlambat4}</td>
              <td>${rows[i].JumlahPulangCepat1}</td>
              <td>${rows[i].JumlahPulangCepat2}</td>
              <td>${rows[i].JumlahPulangCepat3}</td>
              <td>${rows[i].JumlahPulangCepat4}</td>
              <td>${rows[i].ProsentaseKehadiran}</td>
              <td>${rows[i].TotalProsentasePengurangan}</td>
            </tr>
          `

          totalJumlahHari  += rows[i].JumlahHari
          totalJumlahLibur  += rows[i].JumlahLibur
          totalJumlahTugasDinas  += rows[i].JumlahTugasDinas
          totalJumlahTugasBelajar  += rows[i].JumlahTugasBelajar
          totalJumlahSakit  += rows[i].JumlahSakit
          totalJumlahTidakMasukKeterangan  += rows[i].JumlahTidakMasukKeterangan
          totalJumlahCuti  += (rows[i].JumlahCuti + rows[i].JumlahCutiBesar + rows[i].JumlahCTLN)
          totalJumlahKesalahan  += rows[i].JumlahKesalahan 
          totalJumlahAlpa  += rows[i].JumlahAlpa 
          totalJumlahNonApel  += rows[i].JumlahNonApel 
          totalJumlahTerlambat1  += rows[i].JumlahTerlambat1 
          totalJumlahTerlambat2  += rows[i].JumlahTerlambat2 
          totalJumlahTerlambat3  += rows[i].JumlahTerlambat3 
          totalJumlahTerlambat4  += rows[i].JumlahTerlambat4 
          totalJumlahPulangCepat1  += rows[i].JumlahPulangCepat1 
          totalJumlahPulangCepat2  += rows[i].JumlahPulangCepat2 
          totalJumlahPulangCepat3  += rows[i].JumlahPulangCepat3 
          totalJumlahPulangCepat4  += rows[i].JumlahPulangCepat4 
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="3">TOTAL</td>
            <td>${totalJumlahHari}</td>
            <td>${totalJumlahLibur}</td>
            <td>${totalJumlahTugasDinas}</td>
            <td>${totalJumlahTugasBelajar}</td>
            <td>${totalJumlahSakit}</td>
            <td>${totalJumlahTidakMasukKeterangan}</td>
            <td>${totalJumlahCuti}</td>
            <td>${totalJumlahKesalahan}</td>
            <td>${totalJumlahAlpa}</td>
            <td>${totalJumlahNonApel}</td>
            <td>${totalJumlahTerlambat1}</td>
            <td>${totalJumlahTerlambat2}</td>
            <td>${totalJumlahTerlambat3}</td>
            <td>${totalJumlahTerlambat4}</td>
            <td>${totalJumlahPulangCepat1}</td>
            <td>${totalJumlahPulangCepat2}</td>
            <td>${totalJumlahPulangCepat3}</td>
            <td>${totalJumlahPulangCepat4}</td>
            <td>&nbsp;</td>
          </tr>
        `

        const foot = `
          </table>

          <br><br>
          <div>
            <strong>Keterangan:</strong><br>
            TL: Terlambat <br>
            PSW: Pulang Sebelum Waktu
          </div>
        `

        return this.$constant.TEMPLATE_PRINT_HEADER
          + head
          + content
          + foot
          + this.$constant.TEMPLATE_PRINT_FOOTER
      })
    },

    generateReportOPD () {
      const params = this.filter

      return this.$axios.get(this.apiUrl, { params }).then(res => {

        const head = `
          <h2 class="text-center">REKAP PRESENSI PEGAWAI</h2>
          <h2 class="text-center">${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}</h2>
          <h2 class="text-center underlined">BULAN ${this.$helper.getMonthName(this.filter.month).toUpperCase()} ${this.filter.year}</h2>
          <br>

          <table border="1">
          <tr>
            <th>NO</th>
            <th>NIP</th>
            <th>Nama</th>
            <th>Jumlah Hari</th>
            <th>Jumlah Libur</th>
            <th>Tugas Dinas</th>
            <th>Tugas Belajar</th>
            <th>Sakit</th>
            <th>Ijin</th>
            <th>Cuti</th>
            <th>Kendala Mesin</th>
            <th>Alpha</th>
            <th>Tidak Apel</th>
            <th>TL1</th>
            <th>TL2</th>
            <th>TL3</th>
            <th>TL4</th>
            <th>PSW1</th>
            <th>PSW2</th>
            <th>PSW3</th>
            <th>PSW4</th>
            <th>Kehadiran (%)</th>
            <th>Pengurangan (%)</th>
          </tr>
        `

        let totalJumlahHari = 0
        let totalJumlahLibur = 0
        let totalJumlahTugasDinas = 0
        let totalJumlahTugasBelajar = 0
        let totalJumlahSakit = 0
        let totalJumlahTidakMasukKeterangan = 0
        let totalJumlahCuti = 0
        let totalJumlahKesalahan = 0
        let totalJumlahAlpa = 0
        let totalJumlahNonApel = 0
        let totalJumlahTerlambat1 = 0
        let totalJumlahTerlambat2 = 0
        let totalJumlahTerlambat3 = 0
        let totalJumlahTerlambat4 = 0
        let totalJumlahPulangCepat1 = 0
        let totalJumlahPulangCepat2 = 0
        let totalJumlahPulangCepat3 = 0
        let totalJumlahPulangCepat4 = 0

        const rows = res.data.rows

        let content = ''
        for (var i = 0; i < rows.length; i++) {
          content += `
            <tr>
              <td>${i+1}</td>
              <td>${rows[i].EmployeeIdNumber}&nbsp;</td>
              <td>${rows[i].Name}</td>
              <td>${rows[i].JumlahHari}</td>
              <td>${rows[i].JumlahLibur}</td>
              <td>${rows[i].JumlahTugasDinas}</td>
              <td>${rows[i].JumlahTugasBelajar}</td>
              <td>${rows[i].JumlahSakit}</td>
              <td>${rows[i].JumlahTidakMasukKeterangan}</td>
              <td>${rows[i].JumlahCuti + rows[i].JumlahCutiBesar + rows[i].JumlahCTLN}</td>
              <td>${rows[i].JumlahKesalahan}</td>
              <td>${rows[i].JumlahAlpa}</td>
              <td>${rows[i].JumlahNonApel}</td>
              <td>${rows[i].JumlahTerlambat1}</td>
              <td>${rows[i].JumlahTerlambat2}</td>
              <td>${rows[i].JumlahTerlambat3}</td>
              <td>${rows[i].JumlahTerlambat4}</td>
              <td>${rows[i].JumlahPulangCepat1}</td>
              <td>${rows[i].JumlahPulangCepat2}</td>
              <td>${rows[i].JumlahPulangCepat3}</td>
              <td>${rows[i].JumlahPulangCepat4}</td>
              <td>${rows[i].ProsentaseKehadiran}</td>
              <td>${rows[i].TotalProsentasePengurangan}</td>
            </tr>
          `

          totalJumlahHari  += rows[i].JumlahHari
          totalJumlahLibur  += rows[i].JumlahLibur
          totalJumlahTugasDinas  += rows[i].JumlahTugasDinas
          totalJumlahTugasBelajar  += rows[i].JumlahTugasBelajar
          totalJumlahSakit  += rows[i].JumlahSakit
          totalJumlahTidakMasukKeterangan  += rows[i].JumlahTidakMasukKeterangan
          totalJumlahCuti  += (rows[i].JumlahCuti + rows[i].JumlahCutiBesar + rows[i].JumlahCTLN)
          totalJumlahKesalahan  += rows[i].JumlahKesalahan 
          totalJumlahAlpa  += rows[i].JumlahAlpa 
          totalJumlahNonApel  += rows[i].JumlahNonApel 
          totalJumlahTerlambat1  += rows[i].JumlahTerlambat1 
          totalJumlahTerlambat2  += rows[i].JumlahTerlambat2 
          totalJumlahTerlambat3  += rows[i].JumlahTerlambat3 
          totalJumlahTerlambat4  += rows[i].JumlahTerlambat4 
          totalJumlahPulangCepat1  += rows[i].JumlahPulangCepat1 
          totalJumlahPulangCepat2  += rows[i].JumlahPulangCepat2 
          totalJumlahPulangCepat3  += rows[i].JumlahPulangCepat3 
          totalJumlahPulangCepat4  += rows[i].JumlahPulangCepat4 
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="3">TOTAL</td>
            <td>${totalJumlahHari}</td>
            <td>${totalJumlahLibur}</td>
            <td>${totalJumlahTugasDinas}</td>
            <td>${totalJumlahTugasBelajar}</td>
            <td>${totalJumlahSakit}</td>
            <td>${totalJumlahTidakMasukKeterangan}</td>
            <td>${totalJumlahCuti}</td>
            <td>${totalJumlahKesalahan}</td>
            <td>${totalJumlahAlpa}</td>
            <td>${totalJumlahNonApel}</td>
            <td>${totalJumlahTerlambat1}</td>
            <td>${totalJumlahTerlambat2}</td>
            <td>${totalJumlahTerlambat3}</td>
            <td>${totalJumlahTerlambat4}</td>
            <td>${totalJumlahPulangCepat1}</td>
            <td>${totalJumlahPulangCepat2}</td>
            <td>${totalJumlahPulangCepat3}</td>
            <td>${totalJumlahPulangCepat4}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </table>
        `

        content += `
        <br><br>
        <table border="0">
          <tr style="font-weight: bold;">
            <td colspan="7" width="65%">&nbsp;</td>
            <td colspan="2" width="35%" style="text-align:center;">
              ${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">
            KABUPATEN LAMONGAN
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">__________________________</td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">&nbsp;</td>
          </tr>
        </table>
        `

        const foot = `
          </table>

          <br><br>
          <div>
            <strong>Keterangan:</strong><br>
            TL: Terlambat <br>
            PSW: Pulang Sebelum Waktu
          </div>
        `

        return this.$constant.TEMPLATE_PRINT_HEADER
          + head
          + content
          // + foot
          + this.$constant.TEMPLATE_PRINT_FOOTER
      })
    },

    generateReportAlpha () {
      const params = this.filter

      return this.$axios.get(this.apiUrl, { params }).then(res => {

        const head = `
          <h2 class="text-center">REKAP PRESENSI ALPHA PEGAWAI</h2>
          <h2 class="text-center">${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}</h2>
          <h2 class="text-center underlined">BULAN ${this.$helper.getMonthName(this.filter.month).toUpperCase()} ${this.filter.year}</h2>
          <br>

          <table border="1">
          <tr>
            <th>No</th>
            <th>NIP</th>
            <th>Nama</th>
            <th>Jumlah Hari</th>
            <th>Jumlah Libur</th>
            <th>Tugas Dinas</th>
            <th>Tugas Belajar</th>
            <th>Sakit</th>
            <th>Ijin</th>
            <th>Cuti</th>
            <th>Kendala Mesin</th>
            <th>Alpha</th>
            <th>Tidak Apel</th>
            <th>TL1</th>
            <th>TL2</th>
            <th>TL3</th>
            <th>TL4</th>
            <th>PSW1</th>
            <th>PSW2</th>
            <th>PSW3</th>
            <th>PSW4</th>
            <th>Kehadiran (%)</th>
            <th>Pengurangan (%)</th>
          </tr>
        `

        let totalJumlahHari = 0
        let totalJumlahLibur = 0
        let totalJumlahTugasDinas = 0
        let totalJumlahTugasBelajar = 0
        let totalJumlahSakit = 0
        let totalJumlahTidakMasukKeterangan = 0
        let totalJumlahCuti = 0
        let totalJumlahKesalahan = 0
        let totalJumlahAlpa = 0
        let totalJumlahNonApel = 0
        let totalJumlahTerlambat1 = 0
        let totalJumlahTerlambat2 = 0
        let totalJumlahTerlambat3 = 0
        let totalJumlahTerlambat4 = 0
        let totalJumlahPulangCepat1 = 0
        let totalJumlahPulangCepat2 = 0
        let totalJumlahPulangCepat3 = 0
        let totalJumlahPulangCepat4 = 0

        const rows = res.data.rows

        let content = ''
        let n = 0
        for (var i = 0; i < rows.length; i++) {
          if(rows[i].JumlahAlpa > 0){
            n++
            content += `
              <tr>
                <td>${n}</td>
                <td>${rows[i].EmployeeIdNumber}&nbsp;</td>
                <td>${rows[i].Name}</td>
                <td>${rows[i].JumlahHari}</td>
                <td>${rows[i].JumlahLibur}</td>
                <td>${rows[i].JumlahTugasDinas}</td>
                <td>${rows[i].JumlahTugasBelajar}</td>
                <td>${rows[i].JumlahSakit}</td>
                <td>${rows[i].JumlahTidakMasukKeterangan}</td>
                <td>${rows[i].JumlahCuti + rows[i].JumlahCutiBesar + rows[i].JumlahCTLN}</td>
                <td>${rows[i].JumlahKesalahan}</td>
                <td>${rows[i].JumlahAlpa}</td>
                <td>${rows[i].JumlahNonApel}</td>
                <td>${rows[i].JumlahTerlambat1}</td>
                <td>${rows[i].JumlahTerlambat2}</td>
                <td>${rows[i].JumlahTerlambat3}</td>
                <td>${rows[i].JumlahTerlambat4}</td>
                <td>${rows[i].JumlahPulangCepat1}</td>
                <td>${rows[i].JumlahPulangCepat2}</td>
                <td>${rows[i].JumlahPulangCepat3}</td>
                <td>${rows[i].JumlahPulangCepat4}</td>
                <td>${rows[i].ProsentaseKehadiran}</td>
                <td>${rows[i].TotalProsentasePengurangan}</td>
              </tr>
            `

            totalJumlahHari  += rows[i].JumlahHari
            totalJumlahLibur  += rows[i].JumlahLibur
            totalJumlahTugasDinas  += rows[i].JumlahTugasDinas
            totalJumlahTugasBelajar  += rows[i].JumlahTugasBelajar
            totalJumlahSakit  += rows[i].JumlahSakit
            totalJumlahTidakMasukKeterangan  += rows[i].JumlahTidakMasukKeterangan
            totalJumlahCuti  += (rows[i].JumlahCuti + rows[i].JumlahCutiBesar + rows[i].JumlahCTLN)
            totalJumlahKesalahan  += rows[i].JumlahKesalahan 
            totalJumlahAlpa  += rows[i].JumlahAlpa 
            totalJumlahNonApel  += rows[i].JumlahNonApel 
            totalJumlahTerlambat1  += rows[i].JumlahTerlambat1 
            totalJumlahTerlambat2  += rows[i].JumlahTerlambat2 
            totalJumlahTerlambat3  += rows[i].JumlahTerlambat3 
            totalJumlahTerlambat4  += rows[i].JumlahTerlambat4 
            totalJumlahPulangCepat1  += rows[i].JumlahPulangCepat1 
            totalJumlahPulangCepat2  += rows[i].JumlahPulangCepat2 
            totalJumlahPulangCepat3  += rows[i].JumlahPulangCepat3 
            totalJumlahPulangCepat4  += rows[i].JumlahPulangCepat4 
          }
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="3">TOTAL</td>
            <td>${totalJumlahHari}</td>
            <td>${totalJumlahLibur}</td>
            <td>${totalJumlahTugasDinas}</td>
            <td>${totalJumlahTugasBelajar}</td>
            <td>${totalJumlahSakit}</td>
            <td>${totalJumlahTidakMasukKeterangan}</td>
            <td>${totalJumlahCuti}</td>
            <td>${totalJumlahKesalahan}</td>
            <td>${totalJumlahAlpa}</td>
            <td>${totalJumlahNonApel}</td>
            <td>${totalJumlahTerlambat1}</td>
            <td>${totalJumlahTerlambat2}</td>
            <td>${totalJumlahTerlambat3}</td>
            <td>${totalJumlahTerlambat4}</td>
            <td>${totalJumlahPulangCepat1}</td>
            <td>${totalJumlahPulangCepat2}</td>
            <td>${totalJumlahPulangCepat3}</td>
            <td>${totalJumlahPulangCepat4}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        `

        let foot = `
          </table>

          <br><br>
          <div>
            <strong>Keterangan:</strong><br>
            TL: Terlambat <br>
            PSW: Pulang Sebelum Waktu
          </div>
          <br>
        `

        foot += `
        <br><br>
        <table border="0">
          <tr style="font-weight: bold;">
            <td colspan="7" width="65%">&nbsp;</td>
            <td colspan="2" width="35%" style="text-align:center;">
              KEPALA BADAN KEPEGAWAIAN
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">
            DAN PENGEMBANGAN SUMBER DAYA MANUSIA
            
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">
            KABUPATEN LAMONGAN
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;"><u>Drs. SHODIKIN, M.Pd.</u></td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">NIP. 196610191987031008</td>
          </tr>
        </table>
        `

        return this.$constant.TEMPLATE_PRINT_HEADER
          + head
          + content
          + foot
          + this.$constant.TEMPLATE_PRINT_FOOTER
      })
    },

    printToPDF () {
      window.frames['printFrame'].print()
    },

    exportToExcel (e) {
      const elem = e.currentTarget

      if (!elem.getAttribute('download')) {
        this.generateReportAlpha().then(data => {

          let excelContent = data

          const fileName = `${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}`+`-${this.$helper.getMonthName(this.filter.month)}-${this.filter.year}.xls`

          excelContent = excelContent.replace(/<A[^>]*>|<\/A>/g, '')//remove if u want links in your table
          excelContent = excelContent.replace(/<img[^>]*>/gi,'') // remove if u want images in your table
          excelContent = excelContent.replace(/<input[^>]*>|<\/input>/gi, '') // reomves input params

          const ua = window.navigator.userAgent
          const msie = ua.indexOf('MSIE ')

          // If Internet Explorer
          if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            txtArea1.document.open('txt/html','replace')
            txtArea1.document.write(excelContent)
            txtArea1.document.close()
            txtArea1.focus() 
            
            txtArea1.document.execCommand('SaveAs', true, fileName)
          }  
          else {
            const url = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(excelContent))  
            // const url = 'data:application/vnd.ms-excel,' + escape(excelContent)
            // elem.setAttribute('href', url)
            // elem.setAttribute('download', fileName)

            // elem.click()

            return false
          }
        })

      }

      return false
    },

    numberWithDots(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    generateReportRekom () {
      const params = this.filter
      params.employeeTypeId = null

      return this.$axios.get(this.apiUrl, { params }).then(res => {

        const head = `
          <div>
            <img style="display: block; margin: 0 auto;" src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Lambang_Kabupaten_Lamongan.png/1004px-Lambang_Kabupaten_Lamongan.png" width="60px">
          </div>
          <h2 class="text-center">EVALUASI TINGKAT DISIPLIN KERJA TKK PADA</h2>
          <!-- <h2 class="text-center">PEMERINTAH KABUPATEN LAMONGAN</h2> -->
          <h2 class="text-center">${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}</h2>
          <h2 class="text-center underlined" style="text-transform:uppercase">BULAN ${this.$helper.getMonthName(this.filter.month)} TAHUN ${this.filter.year}</h2>
          <br>

          <table border="1">
          <tr>
            <th>NO</th>
            <th>Nama</th>
            <th>NIK</th>
            <th>Besaran Jasa Kinerja Maksimal</th>
            <th>Jumlah Hari Efektif</th>
            <th>Prosentase Kehadiran</th>
            <th colspan="2">Pengurangan Jasa Kinerja</th>
            <th>Besaran Jasa Kinerja yg diterima</th>
            <th>OPD</th>
          </tr>
          <tr>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th colspan="2">7</th>
            <th>8</th>
            <th>9</th>
          </tr>
        `

        let totalPengurangan = 0
        let totalDiterima = 0

        const rows = res.data.rows

        let content = ''
        let no = 0
        for (var i = 0; i < rows.length; i++) {
          if(rows[i].EmployeeTypeID === 8 || rows[i].EmployeeTypeID === 10){
            const jk = 400000
            const nominalPotongan = Math.round((jk * rows[i].ProsentaseKehadiran / 100) - ((jk * rows[i].ProsentaseKehadiran / 100) * rows[i].TotalProsentasePengurangan / 100))
            no += 1
            content += `
              <tr>
                <td style="text-align:center;">${no}</td>
                <td>${rows[i].Name}</td>
                <td>${rows[i].EmployeeIdNumber}&nbsp;</td>
                <td style="text-align:right;">${this.numberWithDots(jk)}</td>
                <td style="text-align:center;">${rows[i].JumlahHari}</td>
                <td style="text-align:center;">${rows[i].ProsentaseKehadiran}%</td>
                <td style="text-align:center;">${rows[i].TotalProsentasePengurangan}%</td>
                <td style="text-align:right;">${this.numberWithDots(jk - nominalPotongan)}</td>
                <td style="text-align:right;">${this.numberWithDots(nominalPotongan)}</td>
                <td>${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}</td>
              </tr>
            `

            totalPengurangan  += nominalPotongan
            totalDiterima  += (400000 - nominalPotongan)
          }
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="6">TOTAL</td>
            <td style="text-align:right;">${this.numberWithDots(totalPengurangan)}</td>
            <td style="text-align:right;">${this.numberWithDots(totalDiterima)}</td>
            <td>&nbsp;</td>
          </tr>
          </table>
        `

        content += `
        <br><br>
        <table border="0">
          <tr style="font-weight: bold;">
            <td colspan="7" width="65%">&nbsp;</td>
            <td colspan="2" width="35%" style="text-align:center;">
              KEPALA BADAN KEPEGAWAIAN
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">
            DAN PENGEMBANGAN SUMBER DAYA MANUSIA
            
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">
            KABUPATEN LAMONGAN
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;"><u>Drs. SHODIKIN, M.Pd.</u></td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">NIP. 196610191987031008</td>
          </tr>
        </table>
        `

        // <tr style="font-weight: bold;">
        //   <td colspan="7">&nbsp;</td>
        //   <td colspan="2" style="">
        //     <div style="background-image: url('/images/other/BKPSDMStempel.png');background-repeat: no-repeat;background-size: contain;height: 4.15cm;margin-left: 35px;margin-top: -28px;margin-bottom: -28px;"></div>
        //   </td>
        // </tr>

        const foot = `
        `
          // </table>

          // <br><br>
          // <div>
          //   <strong>Keterangan:</strong><br>
          //   TL: Terlambat <br>
          //   PSW: Pulang Sebelum Waktu
          // </div>

        return this.$constant.TEMPLATE_PRINT_HEADER
          + head
          + content
          + foot
          + this.$constant.TEMPLATE_PRINT_FOOTER
      })
    },

    generateReportRekomOPD () {
      const params = this.filter
      params.employeeTypeId = null

      return this.$axios.get(this.apiUrl, { params }).then(res => {

        const head = `
          <div>
            <img style="display: block; margin: 0 auto;" src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Lambang_Kabupaten_Lamongan.png/1004px-Lambang_Kabupaten_Lamongan.png" width="60px">
          </div>
          <h2 class="text-center">REKAP PRESENSI PEGAWAI</h2>
          <!-- <h2 class="text-center">PEMERINTAH KABUPATEN LAMONGAN</h2> -->
          <h2 class="text-center">${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}</h2>
          <h2 class="text-center underlined" style="text-transform:uppercase">BULAN ${this.$helper.getMonthName(this.filter.month)} TAHUN ${this.filter.year}</h2>
          <br>

          <table border="1">
          <tr>
            <th>NO</th>
            <th>Nama</th>
            <th>NIK</th>
            <th>Besaran Jasa Kinerja Maksimal</th>
            <th>Jumlah Hari Efektif</th>
            <th>Prosentase Kehadiran</th>
            <th colspan="2">Pengurangan Jasa Kinerja</th>
            <th>Besaran Jasa Kinerja yg diterima</th>
          </tr>
          <tr>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th colspan="2">7</th>
            <th>8</th>
          </tr>
        `

        let totalPengurangan = 0
        let totalDiterima = 0

        const rows = res.data.rows

        let content = ''
        let no = 0
        for (var i = 0; i < rows.length; i++) {
          if(rows[i].EmployeeTypeID === 8 || rows[i].EmployeeTypeID === 10){
            const jk = 400000
            const nominalPotongan = Math.round((jk * rows[i].ProsentaseKehadiran / 100) - ((jk * rows[i].ProsentaseKehadiran / 100) * rows[i].TotalProsentasePengurangan / 100))
            no += 1
            content += `
              <tr>
                <td style="text-align:center;">${no}</td>
                <td>${rows[i].Name}</td>
                <td>${rows[i].EmployeeIdNumber}&nbsp;</td>
                <td style="text-align:right;">${this.numberWithDots(jk)}</td>
                <td style="text-align:center;">${rows[i].JumlahHari}</td>
                <td style="text-align:center;">${rows[i].ProsentaseKehadiran}%</td>
                <td style="text-align:center;">${rows[i].TotalProsentasePengurangan}%</td>
                <td style="text-align:right;">${this.numberWithDots(jk - nominalPotongan)}</td>
                <td style="text-align:right;">${this.numberWithDots(nominalPotongan)}</td>
              </tr>
            `

            totalPengurangan  += nominalPotongan
            totalDiterima  += (400000 - nominalPotongan)
          }
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="6">TOTAL</td>
            <td style="text-align:right;">${this.numberWithDots(totalPengurangan)}</td>
            <td style="text-align:right;">${this.numberWithDots(totalDiterima)}</td>
            <td colspan="2">&nbsp;</td>
          </tr>
          </table>
        `

        content += `
        <br><br>
        <table border="0">
          <tr style="font-weight: bold;">
            <td colspan="7" width="65%">&nbsp;</td>
            <td colspan="2" width="35%" style="text-align:center;">
              ${this.listCompanies.find(c => c.ID === this.filter.companyId).Name}
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">
            KABUPATEN LAMONGAN
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="">
              &nbsp;
            </td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">__________________________</td>
          </tr>
          <tr style="font-weight: bold;">
            <td colspan="7">&nbsp;</td>
            <td colspan="2" style="text-align:center;">&nbsp;</td>
          </tr>
        </table>
        `

        const foot = `
        `
          // </table>

          // <br><br>
          // <div>
          //   <strong>Keterangan:</strong><br>
          //   TL: Terlambat <br>
          //   PSW: Pulang Sebelum Waktu
          // </div>

        return this.$constant.TEMPLATE_PRINT_HEADER
          + head
          + content
          + foot
          + this.$constant.TEMPLATE_PRINT_FOOTER
      })
    },

    printRekomToPDF () {
      window.frames['printRekomFrame'].print()
    },

    exportRekomToExcel (e) {
      const elem = e.currentTarget

      if (!elem.getAttribute('download')) {
        this.generateReport().then(data => {

          let excelContent = data

          const fileName = `rekom-${this.$helper.getMonthName(this.filter.month)}-${this.filter.year}.xls`

          excelContent = excelContent.replace(/<A[^>]*>|<\/A>/g, '')//remove if u want links in your table
          excelContent = excelContent.replace(/<img[^>]*>/gi,'') // remove if u want images in your table
          excelContent = excelContent.replace(/<input[^>]*>|<\/input>/gi, '') // reomves input params

          const ua = window.navigator.userAgent
          const msie = ua.indexOf('MSIE ')

          // If Internet Explorer
          if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            txtArea1.document.open('txt/html','replace')
            txtArea1.document.write(excelContent)
            txtArea1.document.close()
            txtArea1.focus() 
            
            txtArea1.document.execCommand('SaveAs', true, fileName)
          }  
          else {
            const url = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(excelContent))  
            // const url = 'data:application/vnd.ms-excel,' + escape(excelContent)
            // elem.setAttribute('href', url)
            // elem.setAttribute('download', fileName)

            // elem.click()

            return false
          }
        })

      }

      return false
    },
  }
}
</script>

<style scoped>
  .table-cap {
    font-size: 0.8rem;
    border-radius: 5px;
  }
</style>
